import { useAccount, useChainId, useWalletClient } from 'wagmi'
import { BrowserProvider, JsonRpcSigner } from 'ethers'
import { useEffect, useState } from 'react'

export function useEthersFromWagmi() {
  const { address, isConnected } = useAccount()
  const chainId = useChainId()
  const { data: walletClient } = useWalletClient()

  const [provider, setProvider] = useState<BrowserProvider | null>(null)
  const [signer, setSigner] = useState<JsonRpcSigner | null>(null)

  useEffect(() => {
    if (!walletClient || !address || !isConnected) {
      setProvider(null)
      setSigner(null)
      return
    }
    const p = new BrowserProvider(walletClient as unknown as import('ethers').Eip1193Provider)
    setProvider(p)
    let cancelled = false
    p.getSigner()
      .then((s) => {
        if (!cancelled) setSigner(s)
      })
      .catch(() => {
        if (!cancelled) setSigner(null)
      })
    return () => {
      cancelled = true
    }
  }, [walletClient, address, isConnected])

  return {
    provider,
    signer,
    address: address ?? null,
    chainId: isConnected ? chainId : null,
    isConnected,
  }
}
